"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setChangeUserId = exports.setChangePassword = exports.checkUserIdExist = void 0;
var _SecureClient = require("./SecureClient");
const checkUserIdExist = newUserId => {
  const dataForm = new FormData();
  dataForm.append('newUserId', newUserId);
  const secureClient = new _SecureClient.SecureClient();
  return secureClient.postFormData('/security/user/user-id-available', dataForm);
};
exports.checkUserIdExist = checkUserIdExist;
const setChangeUserId = (newUserId, confirmUserId, password) => {
  const dataForm = new FormData();
  dataForm.append('newUserId', newUserId);
  dataForm.append('confirmUserId', confirmUserId);
  dataForm.append('password', password);
  const secureClient = new _SecureClient.SecureClient();
  return secureClient.postFormData('/security/user/update-userid', dataForm);
};
exports.setChangeUserId = setChangeUserId;
const setChangePassword = (password, newPassword, confirmPassword) => {
  const dataForm = new FormData();
  dataForm.append('confirmPassword', confirmPassword);
  dataForm.append('newPassword', newPassword);
  dataForm.append('password', password);
  const secureClient = new _SecureClient.SecureClient();
  return secureClient.postFormData('/security/user/update-password', dataForm);
};
exports.setChangePassword = setChangePassword;
//# sourceMappingURL=Profile.js.map